// extracted by mini-css-extract-plugin
export default {"container":"editableText_container__7fvLc","input":"editableText_input__qyafL","count":"editableText_count__COAMt","text":"editableText_text__zjkqW"};